/*!
 * Copyright © 2026 Nail Alliance - North America, Inc.
 * Authors: See snippets/copyright-notices.liquid in the theme.
 * No other use is authorized without a written contract.
 */

document.querySelectorAll('.source-editorial .carousel-track').forEach(track => {
  const cards = [...track.querySelectorAll('.carousel-card')];
  if (!cards.length) return;
  let index = Math.max(0, cards.findIndex(card => card.classList.contains('active')));
  const container = track.closest('.carousel-container') || track.parentElement.parentElement;
  container.querySelectorAll('[data-carousel-prev], [data-carousel-next]').forEach(button => {
    button.type = 'button';
    button.setAttribute('aria-label', button.hasAttribute('data-carousel-prev') ? 'Previous photo' : 'Next photo');
    button.addEventListener('click', () => {
      index = (index + (button.hasAttribute('data-carousel-prev') ? -1 : 1) + cards.length) % cards.length;
      cards.forEach((card, i) => card.classList.toggle('active', i === index));
      track.style.transform = `translateX(calc(50% - (${index} * (60% + 2rem) + 30%)))`;
    });
  });
});
if (document.querySelector('.source-editorial .instagram-media') && !document.querySelector('script[src="https://www.instagram.com/embed.js"]')) {
  const script = document.createElement('script'); script.src = 'https://www.instagram.com/embed.js'; script.async = true; document.body.append(script);
}
